import { makeStyles, Text } from '@rneui/themed'
import { StyleProp, TextStyle, View, ViewStyle } from 'react-native'

export const ListEmptyComponent = ({
  title,
  containerStyle,
  textStyle,
}: {
  title: string
  containerStyle?: StyleProp<ViewStyle>
  textStyle?: StyleProp<TextStyle>
}) => {
  const styles = useStyles()
  return (
    <View style={[styles.emptyContainer, containerStyle]}>
      <Text style={[styles.text, textStyle]}>{title}</Text>
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: { flex: 1 },
  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 150,
  },
  text: {
    fontSize: 16,
  },
}))
